var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.value)?_c('div',{class:`modal modal--${_vm.type}`},[_c('div',{staticClass:"modal__content"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }